<template>
  <div class="position-relative">
    <div class="table-container">
      <b-table
        class="applicant_table animated fadeIn"
        responsive
        hover
        :fields="fields"
        :items="items"
        primary-key="id"
        :busy="isBusy"
        show-empty
        :empty-text="$t('NO_DATA')"
      >
        <template v-slot:cell(id)="data">
          {{ data.item.id }}
        </template>

        <template v-slot:cell(user)="data">
          <span>
            {{ (data.item.request && data.item.request.first_name) ? data.item.request.first_name : 'Guest' }}
            {{ (data.item.request && data.item.request.last_name) ? data.item.request.last_name : '' }}
          </span>
        </template>

        <template v-slot:cell(status)="data">
          <b-badge
            v-if="data.item && data.item.status != null"
            class="ml-1"
            :variant="data.item.status < 300 ? 'success' : 'danger'"
          >
            {{ data.item.status < 300 ? 'success' : 'failed' }}
          </b-badge>
        </template>

        <template v-slot:cell(started_at)="data">
          {{ data.item.started_at }}
        </template>

        <template v-slot:cell(ended_at)="data">
          {{ data.item.ended_at }}
        </template>
        <template v-slot:cell(error)="data">
         <div v-if="data.item.response && data.item.response.errors && data.item.response.errors.length">
          <span
            class="text-danger"
            v-for="(err, index) in data.item.response.errors"
            :key="index"
            :title="err.message"
          >
            <i class="fa fa-exclamation-circle"></i> {{ err.message }}
          </span>
                </div>
                <span v-else class="text-muted">-</span>
        </template>
        <template v-slot:cell(actions)="data">
          <LogEditButton class="pull-right" :log="data.item" />
        </template>

        <template #table-busy>
          <div class="text-center my-3">
            <b-spinner small class="mr-2" /> {{ $t('LOADING') }}
          </div>
        </template>

        <template #empty>
          <AppNoData />
        </template>
      </b-table>

      <b-pagination
        v-if="totalRows > 0"
        class="app_pagination"
        size="sm"
        :hide-goto-end-buttons="true"
        :value="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="$emit('page-changed', $event)"
      >
        <template v-slot:prev-text>
          <i class="fa fa-angle-left" aria-hidden="true"></i>
        </template>

        <template v-slot:next-text>
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import AppNoData from "@/components/app/AppNoData";
import LogEditButton from '@/components/app/AppEdit';

export default {
  name: "ApiLogListTable",
  components: { AppNoData, LogEditButton },

  props: {
    items: { type: Array, default: () => [] },
    isBusy: { type: Boolean, default: false },
    totalRows: { type: Number, default: 0 },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 }
  },

  data() {
    return {
      fields: [
        { key: "user", label: "User" },
        { key: "path", label: "Path" },
        { key: "status", label: "Status" },
        { key: "started_at", label: "Start" },
        { key: "ended_at", label: "End" },
        { key: "error", label: "Error" },
    /*    { key: "actions", label: "Preview" },*/
      ]
    };
  },
  watch: {
    items: function(newVal, oldVal) {
      console.log(newVal, "newVal")
      console.log(oldVal, "oldVal")
    }
  }
};
</script>
